<button
    [routerLink]="['/sortida-partida', ('000000' + partida.idSortida).slice(-6), partida.idPartida, 'fotos']"
    class="btn btn-lg btn-block btn-dark mt-2"
>
    Imatges
</button>
